export default "__VITE_ASSET__CPEFr9lv__"